import { BlockStoreStats } from '#block-store/types';
import { Logging } from '#common/logging';
import { withStats } from '#common/stats';
import { NotImplementedError } from '#common/types';
export const createBlockStoreMock = (blockStoreMockWasm) => {
    return new BlockStoreMock(blockStoreMockWasm);
};
class BlockStoreMock {
    blockStoreMockWasm;
    static STATS_NAME = 'BlockStoreMock';
    log = Logging.getLogger('BlockStoreMock');
    statistics = new BlockStoreStats(BlockStoreMock.STATS_NAME, this.log);
    constructor(blockStoreMockWasm) {
        this.blockStoreMockWasm = blockStoreMockWasm;
    }
    async get(req) {
        return withStats(this.statistics.get, async () => {
            const blocks = await this.blockStoreMockWasm.getBlocks(req);
            return blocks.map((block) => Promise.resolve(block));
        });
    }
    put(_request) {
        throw new NotImplementedError();
    }
    stats() {
        return this.statistics;
    }
    async stop() { }
}
